import sendLocalRequest from "./sendLocalRequest";

export const getActiveErrors = (auth_token) => {
    return  new Promise( (resolve, reject) => {
        sendLocalRequest(`machines/active_errors`, "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
